<template>
    <div class="voltage-rise-calculator-content">
        <div class="voltage-rise-calculator-content__steps">
            <Steps :class="{'steps--completed': jobCompleted }" :current="steps.active" :total="steps.total" @changeStep="toggle" />
        </div>
        <div v-if="steps.active == 1">
            <VoltageRiseConfiguration
                :job="job"
                :inverters="inverters"
                :view.sync="steps.active"
                :cable-diagram.sync="cableDiagram"
            />
        </div>
        <div v-else>
            <VoltageRiseOutput
                :job-id="job.id"
                :system="inverters"
                :cable-diagram.sync="cableDiagram"
                :view.sync="steps.active"
                @changeStep="toggle"
            />
        </div>
    </div>
</template>

<script>
import { map } from 'lodash';
import Steps from '@/jobs/new/Steps';
import VoltageRiseOutput from './VoltageRiseOutput'
import VoltageRiseConfiguration from './VoltageRiseConfiguration'

export default {
    components: {
        VoltageRiseOutput,
        VoltageRiseConfiguration,
        Steps
    },

    data() {
        return {
            job: JSON.parse(this.$root.job),
            products: JSON.parse(this.$root.products),
            configuration: JSON.parse(this.$root.configuration),
            cableDiagram: null,
            steps: {
                active: 1,
                total: 2
            }
        };
    },

    computed: {
        // Basic config injected with data from product lookup data
        inverters() {
            return map(this.configuration, (system) => {
                return this.products.inverters.inverters.find((i) => i.id == system.id);
            });
        },

        jobCompleted() {
            return this.job.details.commissioningSheet && this.job.details.commissioningSheet.completed == 'true';
        }
    },

    created() {
        if (this.job.details.cableDiagram) {
            this.cableDiagram = this.job.details.cableDiagram;
            this.steps.active = 2;
        }

        if (this.jobCompleted) {
            this.steps.active = 2;
        }
    },

    methods: {
        toggle(step) {
            if (this.job.details.cableDiagram || step === 1) {
                this.steps.active = step;
            }
        },
    }
};
</script>
